<template>    
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs12 class="inline-block px-2">      
      <v-text-field hide-details  :label="$t('Admin.AdminMission.Form.Libelle')" v-model="mis_libelle" />            
      <v-text-field hide-details  type="number" :label="$t('Admin.AdminMission.Form.Index')" v-model.number="mis_idx" />            
      <v-autocomplete hide-details 
        :items="gliders"
        item-text="GLI_LIBELLE"
        item-value="GLI_ID"
        :label="$t('Admin.AdminMission.Form.Glider')"
        v-model="gli_id"
      ></v-autocomplete>
      <v-textarea  auto-grow rows="1"  :label="$t('Admin.AdminMission.Form.Note')" v-model="mis_note" />   
      <v-switch :disabled="!mis_actif" v-model="mis_actif" :label="$t('Admin.AdminMission.Form.MisActif')"></v-switch>
      <v-switch v-if="isSysAdmin" v-model="mis_adminonly" :label="$t('Admin.AdminMission.Form.SysAdminOnly')"></v-switch>      
    </v-flex>                         
  </v-layout>  
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import apiAdminMission from '@/api/admin/adminMission'
import { SecurityRoles } from '@/enum/SecurityItems'

@Component({
  name: 'AdminAdminMissionForm'  
})
export default class AdminAdminMissionForm extends Vue {  

  private isMeasureTypeAssociationUpdating = false

  created() {        
    this.$store.myActions.GLIDER_ENSURE_LIST()
  }


  get isSysAdmin() {
    return this.$store.myGetters.userProfile.roles.some(r => r == SecurityRoles.sysadmin)    
  }

  get gliders() {
    return this.$store.myGetters.gliders
  }

  get modified(){
    return this.$store.myGetters.modifiedAdmAdminMission
  }
    
  get mis_libelle(){
    return this.modified.MIS_LIBELLE!
  }
  set mis_libelle(value:string){    
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      MIS_LIBELLE:value
    })
  }

  get mis_idx(){
    return this.modified.MIS_IDX!
  }
  set mis_idx(value:number){    
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      MIS_IDX:value
    })
  }

  get mis_note(){
    return this.modified.MIS_NOTE!
  }
  set mis_note(value:string){    
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      MIS_NOTE:value
    })
  }
  
   get mis_actif(){
    return this.modified.MIS_ACTIF_ON
  }
  set mis_actif(value:boolean){    
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      MIS_ACTIF_ON:value
    })
  }

   get mis_adminonly(){
    return this.modified.MIS_ADMINONLY_ON
  }
  set mis_adminonly(value:boolean){    
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      MIS_ADMINONLY_ON:value
    })
  }


   get gli_id() {
    return this.modified.GLI_ID!
  }
  set gli_id(value: number) {
    this.$store.myActions.ADMINMISSION_UPDATE_MODIFIED_ADM({
      GLI_ID: value
    })
  }


}
</script>